!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? r(exports) : "function" == typeof define && define.amd ? define(["exports"], r) : r((e = e || self).WebStreamsPolyfill = {});
}(this, function (e) {
  "use strict";

  var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? Symbol : function (e) {
    return "Symbol(" + e + ")";
  };

  var t = "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : void 0,
      o = Number.isNaN || function (e) {
    return e != e;
  };

  function n(e) {
    return "object" == typeof e && null !== e || "function" == typeof e;
  }

  function i(e, r, t) {
    Object.defineProperty(e, r, {
      value: t,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  }

  function a(e) {
    return e.slice();
  }

  function s(e, r, t, o, n) {
    new Uint8Array(e).set(new Uint8Array(t, o, n), r);
  }

  function u(e) {
    return !1 !== function (e) {
      if ("number" != typeof e) return !1;
      if (o(e)) return !1;
      if (e < 0) return !1;
      return !0;
    }(e) && e !== 1 / 0;
  }

  function l(e, r, t) {
    if ("function" != typeof e) throw new TypeError("Argument is not a function");
    return Function.prototype.apply.call(e, r, t);
  }

  function c(e, r, t, o) {
    var n = e[r];

    if (void 0 !== n) {
      if ("function" != typeof n) throw new TypeError(n + " is not a method");

      switch (t) {
        case 0:
          return function () {
            return d(n, e, o);
          };

        case 1:
          return function (r) {
            var t = [r].concat(o);
            return d(n, e, t);
          };
      }
    }

    return function () {
      return Promise.resolve();
    };
  }

  function f(e, r, t) {
    var o = e[r];
    if (void 0 !== o) return l(o, e, t);
  }

  function d(e, r, t) {
    try {
      return Promise.resolve(l(e, r, t));
    } catch (e) {
      return Promise.reject(e);
    }
  }

  function h(e) {
    return e;
  }

  function _(e) {
    if (e = Number(e), o(e) || e < 0) throw new RangeError("highWaterMark property of a queuing strategy must be non-negative and non-NaN");
    return e;
  }

  function b(e) {
    if (void 0 === e) return function () {
      return 1;
    };
    if ("function" != typeof e) throw new TypeError("size property of a queuing strategy must be a function");
    return function (r) {
      return e(r);
    };
  }

  function p(e, r, t) {
    for (var o = !1, n = function n(e) {
      !1 === o && (o = !0, t(e));
    }, i = 0, a = 0, s = e.length, u = new Array(s), l = function l(e) {
      var t = i;
      !function (e, r, t) {
        Promise.prototype.then.call(e, r, t);
      }(e, function (e) {
        u[t] = e, ++a === s && r(u);
      }, n), ++i;
    }, c = 0, f = e; c < f.length; c++) {
      l(f[c]);
    }
  }

  var m = function m() {};

  function y(e) {
    var r = e._queue.shift();

    return e._queueTotalSize -= r.size, e._queueTotalSize < 0 && (e._queueTotalSize = 0), r.value;
  }

  function v(e, r, t) {
    if (!u(t = Number(t))) throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
    e._queue.push({
      value: r,
      size: t
    }), e._queueTotalSize += t;
  }

  function w(e) {
    e._queue = [], e._queueTotalSize = 0;
  }

  var g = r("[[AbortSteps]]"),
      S = r("[[ErrorSteps]]"),
      R = function () {
    function e(e, r) {
      void 0 === e && (e = {}), void 0 === r && (r = {}), T(this);
      var t = r.size,
          o = r.highWaterMark;
      if (void 0 !== e.type) throw new RangeError("Invalid type is specified");
      var n = b(t);
      void 0 === o && (o = 1), function (e, r, t, o) {
        var n = Object.create(x.prototype);
        var i = c(r, "write", 1, [n]),
            a = c(r, "close", 0, []),
            s = c(r, "abort", 1, []);
        Y(e, n, function () {
          return f(r, "start", [n]);
        }, i, a, s, t, o);
      }(this, e, o = _(o), n);
    }

    return Object.defineProperty(e.prototype, "locked", {
      get: function get() {
        if (!1 === q(this)) throw K("locked");
        return j(this);
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.abort = function (e) {
      return !1 === q(this) ? Promise.reject(K("abort")) : !0 === j(this) ? Promise.reject(new TypeError("Cannot abort a stream that already has a writer")) : E(this, e);
    }, e.prototype.getWriter = function () {
      if (!1 === q(this)) throw K("getWriter");
      return P(this);
    }, e;
  }();

  function P(e) {
    return new k(e);
  }

  function T(e) {
    e._state = "writable", e._storedError = void 0, e._writer = void 0, e._writableStreamController = void 0, e._writeRequests = [], e._inFlightWriteRequest = void 0, e._closeRequest = void 0, e._inFlightCloseRequest = void 0, e._pendingAbortRequest = void 0, e._backpressure = !1;
  }

  function q(e) {
    return !!n(e) && !!Object.prototype.hasOwnProperty.call(e, "_writableStreamController");
  }

  function j(e) {
    return void 0 !== e._writer;
  }

  function E(e, r) {
    var t = e._state;
    if ("closed" === t || "errored" === t) return Promise.resolve(void 0);
    if (void 0 !== e._pendingAbortRequest) return e._pendingAbortRequest._promise;
    var o = !1;
    "erroring" === t && (o = !0, r = void 0);
    var n = new Promise(function (t, n) {
      e._pendingAbortRequest = {
        _promise: void 0,
        _resolve: t,
        _reject: n,
        _reason: r,
        _wasAlreadyErroring: o
      };
    });
    return e._pendingAbortRequest._promise = n, !1 === o && A(e, r), n;
  }

  function C(e, r) {
    "writable" !== e._state ? O(e) : A(e, r);
  }

  function A(e, r) {
    var t = e._writableStreamController;
    e._state = "erroring", e._storedError = r;
    var o = e._writer;
    void 0 !== o && M(o, r), !1 === function (e) {
      if (void 0 === e._inFlightWriteRequest && void 0 === e._inFlightCloseRequest) return !1;
      return !0;
    }(e) && !0 === t._started && O(e);
  }

  function O(e) {
    e._state = "errored", e._writableStreamController[S]();

    for (var r = e._storedError, t = 0, o = e._writeRequests; t < o.length; t++) {
      o[t]._reject(r);
    }

    if (e._writeRequests = [], void 0 !== e._pendingAbortRequest) {
      var n = e._pendingAbortRequest;
      if (e._pendingAbortRequest = void 0, !0 === n._wasAlreadyErroring) return n._reject(r), void B(e);

      e._writableStreamController[g](n._reason).then(function () {
        n._resolve(), B(e);
      }, function (r) {
        n._reject(r), B(e);
      });
    } else B(e);
  }

  function W(e) {
    return void 0 !== e._closeRequest || void 0 !== e._inFlightCloseRequest;
  }

  function B(e) {
    void 0 !== e._closeRequest && (e._closeRequest._reject(e._storedError), e._closeRequest = void 0);
    var r = e._writer;
    void 0 !== r && re(r, e._storedError);
  }

  function z(e, r) {
    var t = e._writer;
    void 0 !== t && r !== e._backpressure && (!0 === r ? function (e) {
      oe(e);
    }(t) : se(t)), e._backpressure = r;
  }

  var k = function () {
    function e(e) {
      if (!1 === q(e)) throw new TypeError("WritableStreamDefaultWriter can only be constructed with a WritableStream instance");
      if (!0 === j(e)) throw new TypeError("This stream has already been locked for exclusive writing by another writer");
      this._ownerWritableStream = e, e._writer = this;
      var r = e._state;
      if ("writable" === r) !1 === W(e) && !0 === e._backpressure ? oe(this) : ie(this), $(this);else if ("erroring" === r) ne(this, e._storedError), $(this);else if ("closed" === r) ie(this), function (e) {
        $(e), te(e);
      }(this);else {
        var t = e._storedError;
        ne(this, t), ee(this, t);
      }
    }

    return Object.defineProperty(e.prototype, "closed", {
      get: function get() {
        return !1 === I(this) ? Promise.reject(X("closed")) : this._closedPromise;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "desiredSize", {
      get: function get() {
        if (!1 === I(this)) throw X("desiredSize");
        if (void 0 === this._ownerWritableStream) throw Z("desiredSize");
        return function (e) {
          var r = e._ownerWritableStream,
              t = r._state;
          if ("errored" === t || "erroring" === t) return null;
          if ("closed" === t) return 0;
          return U(r._writableStreamController);
        }(this);
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ready", {
      get: function get() {
        return !1 === I(this) ? Promise.reject(X("ready")) : this._readyPromise;
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.abort = function (e) {
      return !1 === I(this) ? Promise.reject(X("abort")) : void 0 === this._ownerWritableStream ? Promise.reject(Z("abort")) : function (e, r) {
        return E(e._ownerWritableStream, r);
      }(this, e);
    }, e.prototype.close = function () {
      if (!1 === I(this)) return Promise.reject(X("close"));
      var e = this._ownerWritableStream;
      return void 0 === e ? Promise.reject(Z("close")) : !0 === W(e) ? Promise.reject(new TypeError("cannot close an already-closing stream")) : F(this);
    }, e.prototype.releaseLock = function () {
      if (!1 === I(this)) throw X("releaseLock");
      void 0 !== this._ownerWritableStream && D(this);
    }, e.prototype.write = function (e) {
      return !1 === I(this) ? Promise.reject(X("write")) : void 0 === this._ownerWritableStream ? Promise.reject(Z("write to")) : N(this, e);
    }, e;
  }();

  function I(e) {
    return !!n(e) && !!Object.prototype.hasOwnProperty.call(e, "_ownerWritableStream");
  }

  function F(e) {
    var r = e._ownerWritableStream,
        t = r._state;
    if ("closed" === t || "errored" === t) return Promise.reject(new TypeError("The stream (in " + t + " state) is not in the writable state and cannot be closed"));
    var o = new Promise(function (e, t) {
      var o = {
        _resolve: e,
        _reject: t
      };
      r._closeRequest = o;
    });
    return !0 === r._backpressure && "writable" === t && se(e), function (e) {
      v(e, "close", 0), V(e);
    }(r._writableStreamController), o;
  }

  function L(e, r) {
    "pending" === e._closedPromiseState ? re(e, r) : function (e, r) {
      ee(e, r);
    }(e, r);
  }

  function M(e, r) {
    "pending" === e._readyPromiseState ? ae(e, r) : function (e, r) {
      ne(e, r);
    }(e, r);
  }

  function D(e) {
    var r = e._ownerWritableStream,
        t = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
    M(e, t), L(e, t), r._writer = void 0, e._ownerWritableStream = void 0;
  }

  function N(e, r) {
    var t = e._ownerWritableStream,
        o = t._writableStreamController,
        n = function (e, r) {
      try {
        return e._strategySizeAlgorithm(r);
      } catch (r) {
        return Q(e, r), 1;
      }
    }(o, r);

    if (t !== e._ownerWritableStream) return Promise.reject(Z("write to"));
    var i = t._state;
    if ("errored" === i) return Promise.reject(t._storedError);
    if (!0 === W(t) || "closed" === i) return Promise.reject(new TypeError("The stream is closing or closed and cannot be written to"));
    if ("erroring" === i) return Promise.reject(t._storedError);

    var a = function (e) {
      return new Promise(function (r, t) {
        var o = {
          _resolve: r,
          _reject: t
        };

        e._writeRequests.push(o);
      });
    }(t);

    return function (e, r, t) {
      var o = {
        chunk: r
      };

      try {
        v(e, o, t);
      } catch (r) {
        return void Q(e, r);
      }

      var n = e._controlledWritableStream;

      if (!1 === W(n) && "writable" === n._state) {
        var i = G(e);
        z(n, i);
      }

      V(e);
    }(o, r, n), a;
  }

  var x = function () {
    function e() {
      throw new TypeError("WritableStreamDefaultController cannot be constructed explicitly");
    }

    return e.prototype.error = function (e) {
      if (!1 === function (e) {
        if (!n(e)) return !1;
        if (!Object.prototype.hasOwnProperty.call(e, "_controlledWritableStream")) return !1;
        return !0;
      }(this)) throw new TypeError("WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController");
      "writable" === this._controlledWritableStream._state && J(this, e);
    }, e.prototype[g] = function (e) {
      var r = this._abortAlgorithm(e);

      return H(this), r;
    }, e.prototype[S] = function () {
      w(this);
    }, e;
  }();

  function Y(e, r, t, o, n, i, a, s) {
    r._controlledWritableStream = e, e._writableStreamController = r, r._queue = void 0, r._queueTotalSize = void 0, w(r), r._started = !1, r._strategySizeAlgorithm = s, r._strategyHWM = a, r._writeAlgorithm = o, r._closeAlgorithm = n, r._abortAlgorithm = i;
    var u = G(r);
    z(e, u);
    var l = t();
    Promise.resolve(l).then(function () {
      r._started = !0, V(r);
    }, function (t) {
      r._started = !0, C(e, t);
    }).catch(m);
  }

  function H(e) {
    e._writeAlgorithm = void 0, e._closeAlgorithm = void 0, e._abortAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
  }

  function U(e) {
    return e._strategyHWM - e._queueTotalSize;
  }

  function V(e) {
    var r = e._controlledWritableStream;
    if (!1 !== e._started && void 0 === r._inFlightWriteRequest) if ("erroring" !== r._state) {
      if (0 !== e._queue.length) {
        var t = function (e) {
          return e._queue[0].value;
        }(e);

        "close" === t ? function (e) {
          var r = e._controlledWritableStream;
          (function (e) {
            e._inFlightCloseRequest = e._closeRequest, e._closeRequest = void 0;
          })(r), y(e);

          var t = e._closeAlgorithm();

          H(e), t.then(function () {
            !function (e) {
              e._inFlightCloseRequest._resolve(void 0), e._inFlightCloseRequest = void 0, "erroring" === e._state && (e._storedError = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._resolve(), e._pendingAbortRequest = void 0)), e._state = "closed";
              var r = e._writer;
              void 0 !== r && te(r);
            }(r);
          }, function (e) {
            !function (e, r) {
              e._inFlightCloseRequest._reject(r), e._inFlightCloseRequest = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._reject(r), e._pendingAbortRequest = void 0), C(e, r);
            }(r, e);
          }).catch(m);
        }(e) : function (e, r) {
          var t = e._controlledWritableStream;
          (function (e) {
            e._inFlightWriteRequest = e._writeRequests.shift();
          })(t), e._writeAlgorithm(r).then(function () {
            !function (e) {
              e._inFlightWriteRequest._resolve(void 0), e._inFlightWriteRequest = void 0;
            }(t);
            var r = t._state;

            if (y(e), !1 === W(t) && "writable" === r) {
              var o = G(e);
              z(t, o);
            }

            V(e);
          }, function (r) {
            "writable" === t._state && H(e), function (e, r) {
              e._inFlightWriteRequest._reject(r), e._inFlightWriteRequest = void 0, C(e, r);
            }(t, r);
          }).catch(m);
        }(e, t.chunk);
      }
    } else O(r);
  }

  function Q(e, r) {
    "writable" === e._controlledWritableStream._state && J(e, r);
  }

  function G(e) {
    return U(e) <= 0;
  }

  function J(e, r) {
    var t = e._controlledWritableStream;
    H(e), A(t, r);
  }

  function K(e) {
    return new TypeError("WritableStream.prototype." + e + " can only be used on a WritableStream");
  }

  function X(e) {
    return new TypeError("WritableStreamDefaultWriter.prototype." + e + " can only be used on a WritableStreamDefaultWriter");
  }

  function Z(e) {
    return new TypeError("Cannot " + e + " a stream using a released writer");
  }

  function $(e) {
    e._closedPromise = new Promise(function (r, t) {
      e._closedPromise_resolve = r, e._closedPromise_reject = t, e._closedPromiseState = "pending";
    });
  }

  function ee(e, r) {
    $(e), re(e, r);
  }

  function re(e, r) {
    e._closedPromise.catch(function () {}), e._closedPromise_reject(r), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "rejected";
  }

  function te(e) {
    e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "resolved";
  }

  function oe(e) {
    e._readyPromise = new Promise(function (r, t) {
      e._readyPromise_resolve = r, e._readyPromise_reject = t;
    }), e._readyPromiseState = "pending";
  }

  function ne(e, r) {
    oe(e), ae(e, r);
  }

  function ie(e) {
    oe(e), se(e);
  }

  function ae(e, r) {
    e._readyPromise.catch(function () {}), e._readyPromise_reject(r), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "rejected";
  }

  function se(e) {
    e._readyPromise_resolve(void 0), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "fulfilled";
  }

  var ue,
      le,
      ce = Number.isInteger || function (e) {
    return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
  };

  "symbol" == typeof r.asyncIterator && ((ue = {})[r.asyncIterator] = function () {
    return this;
  }, le = ue, Object.defineProperty(le, r.asyncIterator, {
    enumerable: !1
  }));

  var fe = r("[[CancelSteps]]"),
      de = r("[[PullSteps]]"),
      he = function () {
    function e(e, r) {
      void 0 === e && (e = {}), void 0 === r && (r = {}), me(this);
      var t = r.size,
          o = r.highWaterMark,
          n = e.type;

      if ("bytes" === String(n)) {
        if (void 0 !== t) throw new RangeError("The strategy for a byte stream cannot have a size function");
        void 0 === o && (o = 0), function (e, r, t) {
          var o = Object.create($e.prototype);
          var n = c(r, "pull", 0, [o]),
              i = c(r, "cancel", 1, []),
              a = r.autoAllocateChunkSize;
          if (void 0 !== a && (a = Number(a), !1 === ce(a) || a <= 0)) throw new RangeError("autoAllocateChunkSize must be a positive integer");
          !function (e, r, t, o, n, i, a) {
            r._controlledReadableByteStream = e, r._pullAgain = !1, r._pulling = !1, r._byobRequest = void 0, r._queue = r._queueTotalSize = void 0, w(r), r._closeRequested = !1, r._started = !1, r._strategyHWM = _(i), r._pullAlgorithm = o, r._cancelAlgorithm = n, r._autoAllocateChunkSize = a, r._pendingPullIntos = [], e._readableStreamController = r;
            var s = t();
            Promise.resolve(s).then(function () {
              r._started = !0, tr(r);
            }, function (e) {
              _r(r, e);
            }).catch(m);
          }(e, o, function () {
            return f(r, "start", [o]);
          }, n, i, t, a);
        }(this, e, o = _(o));
      } else {
        if (void 0 !== n) throw new RangeError("Invalid type is specified");
        var i = b(t);
        void 0 === o && (o = 1), function (e, r, t, o) {
          var n = Object.create(Ne.prototype);
          var i = c(r, "pull", 0, [n]),
              a = c(r, "cancel", 1, []);
          Xe(e, n, function () {
            return f(r, "start", [n]);
          }, i, a, t, o);
        }(this, e, o = _(o), i);
      }
    }

    return Object.defineProperty(e.prototype, "locked", {
      get: function get() {
        if (!1 === ye(this)) throw mr("locked");
        return ve(this);
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.cancel = function (e) {
      return !1 === ye(this) ? Promise.reject(mr("cancel")) : !0 === ve(this) ? Promise.reject(new TypeError("Cannot cancel a stream that already has a reader")) : Pe(this, e);
    }, e.prototype.getReader = function (e) {
      var r = (void 0 === e ? {} : e).mode;
      if (!1 === ye(this)) throw mr("getReader");
      if (void 0 === r) return be(this, !0);
      if ("byob" === (r = String(r))) return function (e, r) {
        void 0 === r && (r = !1);
        var t = new ze(e);
        return t._forAuthorCode = r, t;
      }(this, !0);
      throw new RangeError("Invalid mode is specified");
    }, e.prototype.pipeThrough = function (e, r) {
      var t = e.writable,
          o = e.readable,
          n = void 0 === r ? {} : r,
          i = n.preventClose,
          a = n.preventAbort,
          s = n.preventCancel,
          u = n.signal;
      if (!1 === ye(this)) throw mr("pipeThrough");
      if (!1 === q(t)) throw new TypeError("writable argument to pipeThrough must be a WritableStream");
      if (!1 === ye(o)) throw new TypeError("readable argument to pipeThrough must be a ReadableStream");
      if (i = Boolean(i), a = Boolean(a), s = Boolean(s), void 0 !== u && !pr(u)) throw new TypeError("ReadableStream.prototype.pipeThrough's signal option must be an AbortSignal");
      if (!0 === ve(this)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream");
      if (!0 === j(t)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream");
      return ge(this, t, i, a, s, u).catch(function () {}), o;
    }, e.prototype.pipeTo = function (e, r) {
      var t = void 0 === r ? {} : r,
          o = t.preventClose,
          n = t.preventAbort,
          i = t.preventCancel,
          a = t.signal;
      return !1 === ye(this) ? Promise.reject(mr("pipeTo")) : !1 === q(e) ? Promise.reject(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream")) : (o = Boolean(o), n = Boolean(n), i = Boolean(i), void 0 === a || pr(a) ? !0 === ve(this) ? Promise.reject(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream")) : !0 === j(e) ? Promise.reject(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream")) : ge(this, e, o, n, i, a) : Promise.reject(new TypeError("ReadableStream.prototype.pipeTo's signal option must be an AbortSignal")));
    }, e.prototype.tee = function () {
      if (!1 === ye(this)) throw mr("tee");

      var e = function (e, r) {
        var t,
            o,
            n,
            i,
            s,
            u = be(e),
            l = !1,
            c = !1,
            f = !1,
            d = new Promise(function (e) {
          s = e;
        });

        function h() {
          return De(u).then(function (e) {
            if (!0 !== l) {
              var r = e.done;
              if (!0 === r) return !1 === c && Ve(n._readableStreamController), !1 === f && Ve(i._readableStreamController), void (l = !0);
              var t = e.value,
                  o = t,
                  a = t;
              !1 === c && Qe(n._readableStreamController, o), !1 === f && Qe(i._readableStreamController, a);
            }
          });
        }

        function _() {}

        return n = pe(_, h, function (r) {
          if (c = !0, t = r, !0 === f) {
            var n = a([t, o]),
                i = Pe(e, n);
            s(i);
          }

          return d;
        }), i = pe(_, h, function (r) {
          if (f = !0, o = r, !0 === c) {
            var n = a([t, o]),
                i = Pe(e, n);
            s(i);
          }

          return d;
        }), u._closedPromise.catch(function (e) {
          Ge(n._readableStreamController, e), Ge(i._readableStreamController, e);
        }), [n, i];
      }(this);

      return a(e);
    }, e.prototype.getIterator = function (e) {
      var r = (void 0 === e ? {} : e).preventCancel;
      if (!1 === ye(this)) throw mr("getIterator");
      var t = be(this),
          o = Object.create(_e);
      return o._asyncIteratorReader = t, o._preventCancel = Boolean(r), o;
    }, e;
  }(),
      _e = {
    next: function next() {
      if (!1 === we(this)) return Promise.reject(yr("next"));
      var e = this._asyncIteratorReader;
      return void 0 === e._ownerReadableStream ? Promise.reject(vr("iterate")) : De(e).then(function (r) {
        var t = r.done;
        return t && Me(e), qe(r.value, t, !0);
      });
    },
    return: function _return(e) {
      if (!1 === we(this)) return Promise.reject(yr("next"));
      var r = this._asyncIteratorReader;
      if (void 0 === r._ownerReadableStream) return Promise.reject(vr("finish iterating"));
      if (r._readRequests.length > 0) return Promise.reject(new TypeError("Tried to release a reader lock when that reader has pending read() calls un-settled"));

      if (!1 === this._preventCancel) {
        var t = Le(r, e);
        return Me(r), t.then(function () {
          return qe(e, !0, !0);
        });
      }

      return Me(r), Promise.resolve(qe(e, !0, !0));
    }
  };

  function be(e, r) {
    void 0 === r && (r = !1);
    var t = new Be(e);
    return t._forAuthorCode = r, t;
  }

  function pe(e, r, t, o, n) {
    void 0 === o && (o = 1), void 0 === n && (n = function n() {
      return 1;
    });
    var i = Object.create(he.prototype);
    return me(i), Xe(i, Object.create(Ne.prototype), e, r, t, o, n), i;
  }

  function me(e) {
    e._state = "readable", e._reader = void 0, e._storedError = void 0, e._disturbed = !1;
  }

  function ye(e) {
    return !!n(e) && !!Object.prototype.hasOwnProperty.call(e, "_readableStreamController");
  }

  function ve(e) {
    return void 0 !== e._reader;
  }

  function we(e) {
    return !!n(e) && !!Object.prototype.hasOwnProperty.call(e, "_asyncIteratorReader");
  }

  function ge(e, r, t, o, n, i) {
    var a = be(e),
        s = P(r),
        u = !1,
        l = Promise.resolve();
    return new Promise(function (c, f) {
      var d;

      if (void 0 !== i) {
        if (d = function d() {
          var t = new DOMException("Aborted", "AbortError"),
              i = [];
          !1 === o && i.push(function () {
            return "writable" === r._state ? E(r, t) : Promise.resolve();
          }), !1 === n && i.push(function () {
            return "readable" === e._state ? Pe(e, t) : Promise.resolve();
          }), y(function () {
            return function (e, r, t) {
              var o, n;
              void 0 === t && (t = void 0);
              var i = new Promise(function (e, r) {
                o = e, n = r;
              });
              return void 0 === t && (t = function t(e) {
                throw e;
              }), p(e, function (e) {
                try {
                  var t = r(e);
                  o(t);
                } catch (e) {
                  n(e);
                }
              }, function (e) {
                try {
                  var r = t(e);
                  o(r);
                } catch (e) {
                  n(e);
                }
              }), i;
            }(i.map(function (e) {
              return e();
            }), function (e) {
              return e;
            });
          }, !0, t);
        }, !0 === i.aborted) return void d();
        i.addEventListener("abort", d);
      }

      if (b(e, a._closedPromise, function (e) {
        !1 === o ? y(function () {
          return E(r, e);
        }, !0, e) : v(!0, e);
      }), b(r, s._closedPromise, function (r) {
        !1 === n ? y(function () {
          return Pe(e, r);
        }, !0, r) : v(!0, r);
      }), function (e, r, t) {
        "closed" === e._state ? t() : r.then(t).catch(m);
      }(e, a._closedPromise, function () {
        !1 === t ? y(function () {
          return function (e) {
            var r = e._ownerWritableStream,
                t = r._state;
            return !0 === W(r) || "closed" === t ? Promise.resolve() : "errored" === t ? Promise.reject(r._storedError) : F(e);
          }(s);
        }) : v();
      }), !0 === W(r) || "closed" === r._state) {
        var h = new TypeError("the destination writable stream closed before all data could be piped to it");
        !1 === n ? y(function () {
          return Pe(e, h);
        }, !0, h) : v(!0, h);
      }

      function _() {
        var e = l;
        return l.then(function () {
          return e !== l ? _() : void 0;
        });
      }

      function b(e, r, t) {
        "errored" === e._state ? t(e._storedError) : r.catch(t).catch(m);
      }

      function y(e, t, o) {
        function n() {
          e().then(function () {
            return w(t, o);
          }, function (e) {
            return w(!0, e);
          }).catch(m);
        }

        !0 !== u && (u = !0, "writable" === r._state && !1 === W(r) ? _().then(n) : n());
      }

      function v(e, t) {
        !0 !== u && (u = !0, "writable" === r._state && !1 === W(r) ? _().then(function () {
          return w(e, t);
        }).catch(m) : w(e, t));
      }

      function w(e, r) {
        D(s), Me(a), void 0 !== i && i.removeEventListener("abort", d), e ? f(r) : c(void 0);
      }

      new Promise(function (e, r) {
        !function t(o) {
          o ? e() : (!0 === u ? Promise.resolve(!0) : s._readyPromise.then(function () {
            return De(a).then(function (e) {
              var r = e.value,
                  t = e.done;
              return !0 === t || (l = N(s, r).catch(function () {}), !1);
            });
          })).then(t, r);
        }(!1);
      }).catch(m);
    });
  }

  function Se(e) {
    return new Promise(function (r, t) {
      var o = {
        _resolve: r,
        _reject: t
      };

      e._reader._readIntoRequests.push(o);
    });
  }

  function Re(e) {
    return new Promise(function (r, t) {
      var o = {
        _resolve: r,
        _reject: t
      };

      e._reader._readRequests.push(o);
    });
  }

  function Pe(e, r) {
    return e._disturbed = !0, "closed" === e._state ? Promise.resolve(void 0) : "errored" === e._state ? Promise.reject(e._storedError) : (Te(e), e._readableStreamController[fe](r).then(function () {}));
  }

  function Te(e) {
    e._state = "closed";
    var r = e._reader;

    if (void 0 !== r) {
      if (Ie(r)) {
        for (var t = 0, o = r._readRequests; t < o.length; t++) {
          (0, o[t]._resolve)(qe(void 0, !0, r._forAuthorCode));
        }

        r._readRequests = [];
      }

      Pr(r);
    }
  }

  function qe(e, r, t) {
    var o = null;
    !0 === t && (o = Object.prototype);
    var n = Object.create(o);
    return Object.defineProperty(n, "value", {
      value: e,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), Object.defineProperty(n, "done", {
      value: r,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), n;
  }

  function je(e, r) {
    e._state = "errored", e._storedError = r;
    var t = e._reader;

    if (void 0 !== t) {
      if (Ie(t)) {
        for (var o = 0, n = t._readRequests; o < n.length; o++) {
          n[o]._reject(r);
        }

        t._readRequests = [];
      } else {
        for (var i = 0, a = t._readIntoRequests; i < a.length; i++) {
          a[i]._reject(r);
        }

        t._readIntoRequests = [];
      }

      Rr(t, r);
    }
  }

  function Ee(e, r, t) {
    var o = e._reader;

    o._readRequests.shift()._resolve(qe(r, t, o._forAuthorCode));
  }

  function Ce(e) {
    return e._reader._readIntoRequests.length;
  }

  function Ae(e) {
    return e._reader._readRequests.length;
  }

  function Oe(e) {
    var r = e._reader;
    return void 0 !== r && !!ke(r);
  }

  function We(e) {
    var r = e._reader;
    return void 0 !== r && !!Ie(r);
  }

  void 0 !== le && Object.setPrototypeOf(_e, le), Object.defineProperty(_e, "next", {
    enumerable: !1
  }), Object.defineProperty(_e, "return", {
    enumerable: !1
  }), "symbol" == typeof r.asyncIterator && Object.defineProperty(he.prototype, r.asyncIterator, {
    value: he.prototype.getIterator,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });

  var Be = function () {
    function e(e) {
      if (!1 === ye(e)) throw new TypeError("ReadableStreamDefaultReader can only be constructed with a ReadableStream instance");
      if (!0 === ve(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
      Fe(this, e), this._readRequests = [];
    }

    return Object.defineProperty(e.prototype, "closed", {
      get: function get() {
        return Ie(this) ? this._closedPromise : Promise.reject(wr("closed"));
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.cancel = function (e) {
      return Ie(this) ? void 0 === this._ownerReadableStream ? Promise.reject(vr("cancel")) : Le(this, e) : Promise.reject(wr("cancel"));
    }, e.prototype.read = function () {
      return Ie(this) ? void 0 === this._ownerReadableStream ? Promise.reject(vr("read from")) : De(this) : Promise.reject(wr("read"));
    }, e.prototype.releaseLock = function () {
      if (!Ie(this)) throw wr("releaseLock");

      if (void 0 !== this._ownerReadableStream) {
        if (this._readRequests.length > 0) throw new TypeError("Tried to release a reader lock when that reader has pending read() calls un-settled");
        Me(this);
      }
    }, e;
  }(),
      ze = function () {
    function e(e) {
      if (!ye(e)) throw new TypeError("ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a byte source");
      if (!1 === er(e._readableStreamController)) throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
      if (ve(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
      Fe(this, e), this._readIntoRequests = [];
    }

    return Object.defineProperty(e.prototype, "closed", {
      get: function get() {
        return ke(this) ? this._closedPromise : Promise.reject(Tr("closed"));
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.cancel = function (e) {
      return ke(this) ? void 0 === this._ownerReadableStream ? Promise.reject(vr("cancel")) : Le(this, e) : Promise.reject(Tr("cancel"));
    }, e.prototype.read = function (e) {
      return ke(this) ? void 0 === this._ownerReadableStream ? Promise.reject(vr("read from")) : ArrayBuffer.isView(e) ? (e.buffer, 0 === e.byteLength ? Promise.reject(new TypeError("view must have non-zero byteLength")) : function (e, r) {
        var t = e._ownerReadableStream;
        if (t._disturbed = !0, "errored" === t._state) return Promise.reject(t._storedError);
        return function (e, r) {
          var t = e._controlledReadableByteStream,
              o = 1;
          r.constructor !== DataView && (o = r.constructor.BYTES_PER_ELEMENT);
          var n = r.constructor,
              i = {
            buffer: h(r.buffer),
            byteOffset: r.byteOffset,
            byteLength: r.byteLength,
            bytesFilled: 0,
            elementSize: o,
            ctor: n,
            readerType: "byob"
          };
          if (e._pendingPullIntos.length > 0) return e._pendingPullIntos.push(i), Se(t);

          if ("closed" === t._state) {
            var a = new n(i.buffer, i.byteOffset, 0);
            return Promise.resolve(qe(a, !0, t._reader._forAuthorCode));
          }

          if (e._queueTotalSize > 0) {
            if (!0 === ar(e, i)) {
              var s = nr(i);
              return ur(e), Promise.resolve(qe(s, !1, t._reader._forAuthorCode));
            }

            if (!0 === e._closeRequested) {
              var u = new TypeError("Insufficient bytes to fill elements in the given buffer");
              return _r(e, u), Promise.reject(u);
            }
          }

          e._pendingPullIntos.push(i);

          var l = Se(t);
          return tr(e), l;
        }(t._readableStreamController, r);
      }(this, e)) : Promise.reject(new TypeError("view must be an array buffer view")) : Promise.reject(Tr("read"));
    }, e.prototype.releaseLock = function () {
      if (!ke(this)) throw Tr("releaseLock");

      if (void 0 !== this._ownerReadableStream) {
        if (this._readIntoRequests.length > 0) throw new TypeError("Tried to release a reader lock when that reader has pending read() calls un-settled");
        Me(this);
      }
    }, e;
  }();

  function ke(e) {
    return !!n(e) && !!Object.prototype.hasOwnProperty.call(e, "_readIntoRequests");
  }

  function Ie(e) {
    return !!n(e) && !!Object.prototype.hasOwnProperty.call(e, "_readRequests");
  }

  function Fe(e, r) {
    e._forAuthorCode = !0, e._ownerReadableStream = r, r._reader = e, "readable" === r._state ? gr(e) : "closed" === r._state ? function (e) {
      gr(e), Pr(e);
    }(e) : Sr(e, r._storedError);
  }

  function Le(e, r) {
    return Pe(e._ownerReadableStream, r);
  }

  function Me(e) {
    "readable" === e._ownerReadableStream._state ? Rr(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")) : function (e, r) {
      Sr(e, r);
    }(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")), e._ownerReadableStream._reader = void 0, e._ownerReadableStream = void 0;
  }

  function De(e) {
    var r = e._ownerReadableStream;
    return r._disturbed = !0, "closed" === r._state ? Promise.resolve(qe(void 0, !0, e._forAuthorCode)) : "errored" === r._state ? Promise.reject(r._storedError) : r._readableStreamController[de]();
  }

  var Ne = function () {
    function e() {
      throw new TypeError();
    }

    return Object.defineProperty(e.prototype, "desiredSize", {
      get: function get() {
        if (!1 === xe(this)) throw qr("desiredSize");
        return Je(this);
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.close = function () {
      if (!1 === xe(this)) throw qr("close");
      if (!1 === Ke(this)) throw new TypeError("The stream is not in a state that permits close");
      Ve(this);
    }, e.prototype.enqueue = function (e) {
      if (!1 === xe(this)) throw qr("enqueue");
      if (!1 === Ke(this)) throw new TypeError("The stream is not in a state that permits enqueue");
      return Qe(this, e);
    }, e.prototype.error = function (e) {
      if (!1 === xe(this)) throw qr("error");
      Ge(this, e);
    }, e.prototype[fe] = function (e) {
      w(this);

      var r = this._cancelAlgorithm(e);

      return Ue(this), r;
    }, e.prototype[de] = function () {
      var e = this._controlledReadableStream;

      if (this._queue.length > 0) {
        var r = y(this);
        return !0 === this._closeRequested && 0 === this._queue.length ? (Ue(this), Te(e)) : Ye(this), Promise.resolve(qe(r, !1, e._reader._forAuthorCode));
      }

      var t = Re(e);
      return Ye(this), t;
    }, e;
  }();

  function xe(e) {
    return !!n(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableStream");
  }

  function Ye(e) {
    !1 !== He(e) && (!0 !== e._pulling ? (e._pulling = !0, e._pullAlgorithm().then(function () {
      e._pulling = !1, !0 === e._pullAgain && (e._pullAgain = !1, Ye(e));
    }, function (r) {
      Ge(e, r);
    }).catch(m)) : e._pullAgain = !0);
  }

  function He(e) {
    var r = e._controlledReadableStream;
    return !1 !== Ke(e) && !1 !== e._started && (!0 === ve(r) && Ae(r) > 0 || Je(e) > 0);
  }

  function Ue(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
  }

  function Ve(e) {
    var r = e._controlledReadableStream;
    e._closeRequested = !0, 0 === e._queue.length && (Ue(e), Te(r));
  }

  function Qe(e, r) {
    var t = e._controlledReadableStream;
    if (!0 === ve(t) && Ae(t) > 0) Ee(t, r, !1);else {
      var o = void 0;

      try {
        o = e._strategySizeAlgorithm(r);
      } catch (r) {
        throw Ge(e, r), r;
      }

      try {
        v(e, r, o);
      } catch (r) {
        throw Ge(e, r), r;
      }
    }
    Ye(e);
  }

  function Ge(e, r) {
    var t = e._controlledReadableStream;
    "readable" === t._state && (w(e), Ue(e), je(t, r));
  }

  function Je(e) {
    var r = e._controlledReadableStream._state;
    return "errored" === r ? null : "closed" === r ? 0 : e._strategyHWM - e._queueTotalSize;
  }

  function Ke(e) {
    var r = e._controlledReadableStream._state;
    return !1 === e._closeRequested && "readable" === r;
  }

  function Xe(e, r, t, o, n, i, a) {
    r._controlledReadableStream = e, r._queue = void 0, r._queueTotalSize = void 0, w(r), r._started = !1, r._closeRequested = !1, r._pullAgain = !1, r._pulling = !1, r._strategySizeAlgorithm = a, r._strategyHWM = i, r._pullAlgorithm = o, r._cancelAlgorithm = n, e._readableStreamController = r;
    var s = t();
    Promise.resolve(s).then(function () {
      r._started = !0, Ye(r);
    }, function (e) {
      Ge(r, e);
    }).catch(m);
  }

  var Ze = function () {
    function e() {
      throw new TypeError("ReadableStreamBYOBRequest cannot be used directly");
    }

    return Object.defineProperty(e.prototype, "view", {
      get: function get() {
        if (!1 === rr(this)) throw jr("view");
        return this._view;
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.respond = function (e) {
      if (!1 === rr(this)) throw jr("respond");
      if (void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
      this._view.buffer, function (e, r) {
        if (!1 === u(r = Number(r))) throw new RangeError("bytesWritten must be a finite");
        fr(e, r);
      }(this._associatedReadableByteStreamController, e);
    }, e.prototype.respondWithNewView = function (e) {
      if (!1 === rr(this)) throw jr("respond");
      if (void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
      if (!ArrayBuffer.isView(e)) throw new TypeError("You can only respond with array buffer views");
      e.buffer, function (e, r) {
        var t = e._pendingPullIntos[0];
        if (t.byteOffset + t.bytesFilled !== r.byteOffset) throw new RangeError("The region specified by view does not match byobRequest");
        if (t.byteLength !== r.byteLength) throw new RangeError("The buffer of view has different capacity than byobRequest");
        t.buffer = r.buffer, fr(e, r.byteLength);
      }(this._associatedReadableByteStreamController, e);
    }, e;
  }(),
      $e = function () {
    function e() {
      throw new TypeError("ReadableByteStreamController constructor cannot be used directly");
    }

    return Object.defineProperty(e.prototype, "byobRequest", {
      get: function get() {
        if (!1 === er(this)) throw Er("byobRequest");

        if (void 0 === this._byobRequest && this._pendingPullIntos.length > 0) {
          var e = this._pendingPullIntos[0],
              r = new Uint8Array(e.buffer, e.byteOffset + e.bytesFilled, e.byteLength - e.bytesFilled),
              t = Object.create(Ze.prototype);
          !function (e, r, t) {
            e._associatedReadableByteStreamController = r, e._view = t;
          }(t, this, r), this._byobRequest = t;
        }

        return this._byobRequest;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "desiredSize", {
      get: function get() {
        if (!1 === er(this)) throw Er("desiredSize");
        return br(this);
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.close = function () {
      if (!1 === er(this)) throw Er("close");
      if (!0 === this._closeRequested) throw new TypeError("The stream has already been closed; do not close it again!");
      var e = this._controlledReadableByteStream._state;
      if ("readable" !== e) throw new TypeError("The stream (in " + e + " state) is not in the readable state and cannot be closed");
      !function (e) {
        var r = e._controlledReadableByteStream;
        if (e._queueTotalSize > 0) return void (e._closeRequested = !0);

        if (e._pendingPullIntos.length > 0) {
          var t = e._pendingPullIntos[0];

          if (t.bytesFilled > 0) {
            var o = new TypeError("Insufficient bytes to fill elements in the given buffer");
            throw _r(e, o), o;
          }
        }

        hr(e), Te(r);
      }(this);
    }, e.prototype.enqueue = function (e) {
      if (!1 === er(this)) throw Er("enqueue");
      if (!0 === this._closeRequested) throw new TypeError("stream is closed or draining");
      var r = this._controlledReadableByteStream._state;
      if ("readable" !== r) throw new TypeError("The stream (in " + r + " state) is not in the readable state and cannot be enqueued to");
      if (!ArrayBuffer.isView(e)) throw new TypeError("You can only enqueue array buffer views when using a ReadableByteStreamController");
      e.buffer, function (e, r) {
        var t = e._controlledReadableByteStream,
            o = r.buffer,
            n = r.byteOffset,
            i = r.byteLength,
            a = h(o);
        if (!0 === We(t)) {
          if (0 === Ae(t)) ir(e, a, n, i);else {
            var s = new Uint8Array(a, n, i);
            Ee(t, s, !1);
          }
        } else !0 === Oe(t) ? (ir(e, a, n, i), cr(e)) : ir(e, a, n, i);
        tr(e);
      }(this, e);
    }, e.prototype.error = function (e) {
      if (!1 === er(this)) throw Er("error");

      _r(this, e);
    }, e.prototype[fe] = function (e) {
      this._pendingPullIntos.length > 0 && (this._pendingPullIntos[0].bytesFilled = 0);
      w(this);

      var r = this._cancelAlgorithm(e);

      return hr(this), r;
    }, e.prototype[de] = function () {
      var e = this._controlledReadableByteStream;

      if (this._queueTotalSize > 0) {
        var r = this._queue.shift();

        this._queueTotalSize -= r.byteLength, ur(this);
        var t = void 0;

        try {
          t = new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
        } catch (e) {
          return Promise.reject(e);
        }

        return Promise.resolve(qe(t, !1, e._reader._forAuthorCode));
      }

      var o = this._autoAllocateChunkSize;

      if (void 0 !== o) {
        var n = void 0;

        try {
          n = new ArrayBuffer(o);
        } catch (e) {
          return Promise.reject(e);
        }

        var i = {
          buffer: n,
          byteOffset: 0,
          byteLength: o,
          bytesFilled: 0,
          elementSize: 1,
          ctor: Uint8Array,
          readerType: "default"
        };

        this._pendingPullIntos.push(i);
      }

      var a = Re(e);
      return tr(this), a;
    }, e;
  }();

  function er(e) {
    return !!n(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableByteStream");
  }

  function rr(e) {
    return !!n(e) && !!Object.prototype.hasOwnProperty.call(e, "_associatedReadableByteStreamController");
  }

  function tr(e) {
    !1 !== function (e) {
      var r = e._controlledReadableByteStream;
      if ("readable" !== r._state) return !1;
      if (!0 === e._closeRequested) return !1;
      if (!1 === e._started) return !1;
      if (!0 === We(r) && Ae(r) > 0) return !0;
      if (!0 === Oe(r) && Ce(r) > 0) return !0;
      if (br(e) > 0) return !0;
      return !1;
    }(e) && (!0 !== e._pulling ? (e._pulling = !0, e._pullAlgorithm().then(function () {
      e._pulling = !1, !0 === e._pullAgain && (e._pullAgain = !1, tr(e));
    }, function (r) {
      _r(e, r);
    }).catch(m)) : e._pullAgain = !0);
  }

  function or(e, r) {
    var t = !1;
    "closed" === e._state && (t = !0);
    var o = nr(r);
    "default" === r.readerType ? Ee(e, o, t) : function (e, r, t) {
      var o = e._reader;

      o._readIntoRequests.shift()._resolve(qe(r, t, o._forAuthorCode));
    }(e, o, t);
  }

  function nr(e) {
    var r = e.bytesFilled,
        t = e.elementSize;
    return new e.ctor(e.buffer, e.byteOffset, r / t);
  }

  function ir(e, r, t, o) {
    e._queue.push({
      buffer: r,
      byteOffset: t,
      byteLength: o
    }), e._queueTotalSize += o;
  }

  function ar(e, r) {
    var t = r.elementSize,
        o = r.bytesFilled - r.bytesFilled % t,
        n = Math.min(e._queueTotalSize, r.byteLength - r.bytesFilled),
        i = r.bytesFilled + n,
        a = i - i % t,
        u = n,
        l = !1;
    a > o && (u = a - r.bytesFilled, l = !0);

    for (var c = e._queue; u > 0;) {
      var f = c[0],
          d = Math.min(u, f.byteLength),
          h = r.byteOffset + r.bytesFilled;
      s(r.buffer, h, f.buffer, f.byteOffset, d), f.byteLength === d ? c.shift() : (f.byteOffset += d, f.byteLength -= d), e._queueTotalSize -= d, sr(e, d, r), u -= d;
    }

    return l;
  }

  function sr(e, r, t) {
    lr(e), t.bytesFilled += r;
  }

  function ur(e) {
    0 === e._queueTotalSize && !0 === e._closeRequested ? (hr(e), Te(e._controlledReadableByteStream)) : tr(e);
  }

  function lr(e) {
    void 0 !== e._byobRequest && (e._byobRequest._associatedReadableByteStreamController = void 0, e._byobRequest._view = void 0, e._byobRequest = void 0);
  }

  function cr(e) {
    for (; e._pendingPullIntos.length > 0;) {
      if (0 === e._queueTotalSize) return;
      var r = e._pendingPullIntos[0];
      !0 === ar(e, r) && (dr(e), or(e._controlledReadableByteStream, r));
    }
  }

  function fr(e, r) {
    var t = e._pendingPullIntos[0];

    if ("closed" === e._controlledReadableByteStream._state) {
      if (0 !== r) throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
      !function (e, r) {
        r.buffer = h(r.buffer);
        var t = e._controlledReadableByteStream;
        if (!0 === Oe(t)) for (; Ce(t) > 0;) {
          or(t, dr(e));
        }
      }(e, t);
    } else !function (e, r, t) {
      if (t.bytesFilled + r > t.byteLength) throw new RangeError("bytesWritten out of range");

      if (sr(e, r, t), !(t.bytesFilled < t.elementSize)) {
        dr(e);
        var o = t.bytesFilled % t.elementSize;

        if (o > 0) {
          var n = t.byteOffset + t.bytesFilled,
              i = t.buffer.slice(n - o, n);
          ir(e, i, 0, i.byteLength);
        }

        t.buffer = h(t.buffer), t.bytesFilled -= o, or(e._controlledReadableByteStream, t), cr(e);
      }
    }(e, r, t);

    tr(e);
  }

  function dr(e) {
    var r = e._pendingPullIntos.shift();

    return lr(e), r;
  }

  function hr(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0;
  }

  function _r(e, r) {
    var t = e._controlledReadableByteStream;
    "readable" === t._state && (!function (e) {
      lr(e), e._pendingPullIntos = [];
    }(e), w(e), hr(e), je(t, r));
  }

  function br(e) {
    var r = e._controlledReadableByteStream._state;
    return "errored" === r ? null : "closed" === r ? 0 : e._strategyHWM - e._queueTotalSize;
  }

  function pr(e) {
    if ("object" != typeof e || null === e) return !1;
    var r = Object.getOwnPropertyDescriptor(AbortSignal.prototype, "aborted").get;

    try {
      return r.call(e), !0;
    } catch (e) {
      return !1;
    }
  }

  function mr(e) {
    return new TypeError("ReadableStream.prototype." + e + " can only be used on a ReadableStream");
  }

  function yr(e) {
    return new TypeError("ReadableStreamAsyncIterator." + e + " can only be used on a ReadableSteamAsyncIterator");
  }

  function vr(e) {
    return new TypeError("Cannot " + e + " a stream using a released reader");
  }

  function wr(e) {
    return new TypeError("ReadableStreamDefaultReader.prototype." + e + " can only be used on a ReadableStreamDefaultReader");
  }

  function gr(e) {
    e._closedPromise = new Promise(function (r, t) {
      e._closedPromise_resolve = r, e._closedPromise_reject = t;
    });
  }

  function Sr(e, r) {
    gr(e), Rr(e, r);
  }

  function Rr(e, r) {
    e._closedPromise.catch(function () {}), e._closedPromise_reject(r), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0;
  }

  function Pr(e) {
    e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0;
  }

  function Tr(e) {
    return new TypeError("ReadableStreamBYOBReader.prototype." + e + " can only be used on a ReadableStreamBYOBReader");
  }

  function qr(e) {
    return new TypeError("ReadableStreamDefaultController.prototype." + e + " can only be used on a ReadableStreamDefaultController");
  }

  function jr(e) {
    return new TypeError("ReadableStreamBYOBRequest.prototype." + e + " can only be used on a ReadableStreamBYOBRequest");
  }

  function Er(e) {
    return new TypeError("ReadableByteStreamController.prototype." + e + " can only be used on a ReadableByteStreamController");
  }

  var Cr = function () {
    function e(e) {
      i(this, "highWaterMark", e.highWaterMark);
    }

    return e.prototype.size = function (e) {
      return e.byteLength;
    }, e;
  }(),
      Ar = function () {
    function e(e) {
      i(this, "highWaterMark", e.highWaterMark);
    }

    return e.prototype.size = function () {
      return 1;
    }, e;
  }(),
      Or = function () {
    function e(e, r, t) {
      void 0 === e && (e = {}), void 0 === r && (r = {}), void 0 === t && (t = {});
      var o = r.size,
          n = r.highWaterMark,
          i = t.size,
          a = t.highWaterMark;
      if (void 0 !== e.writableType) throw new RangeError("Invalid writable type specified");
      var s = b(o);
      if (void 0 === n && (n = 1), n = _(n), void 0 !== e.readableType) throw new RangeError("Invalid readable type specified");
      var u,
          l = b(i);
      void 0 === a && (a = 0), a = _(a), function (e, r, t, o, n, i) {
        function a() {
          return r;
        }

        e._writable = function (e, r, t, o, n, i) {
          void 0 === n && (n = 1), void 0 === i && (i = function i() {
            return 1;
          });
          var a = Object.create(R.prototype);
          return T(a), Y(a, Object.create(x.prototype), e, r, t, o, n, i), a;
        }(a, function (r) {
          return function (e, r) {
            var t = e._transformStreamController;

            if (!0 === e._backpressure) {
              var o = e._backpressureChangePromise;
              return o.then(function () {
                var o = e._writable,
                    n = o._state;
                if ("erroring" === n) throw o._storedError;
                return Dr(t, r);
              });
            }

            return Dr(t, r);
          }(e, r);
        }, function () {
          return function (e) {
            var r = e._readable,
                t = e._transformStreamController,
                o = t._flushAlgorithm();

            return Lr(t), o.then(function () {
              if ("errored" === r._state) throw r._storedError;
              var e = r._readableStreamController;
              !0 === Ke(e) && Ve(e);
            }).catch(function (t) {
              throw Br(e, t), r._storedError;
            });
          }(e);
        }, function (r) {
          return function (e, r) {
            return Br(e, r), Promise.resolve();
          }(e, r);
        }, t, o), e._readable = pe(a, function () {
          return function (e) {
            return kr(e, !1), e._backpressureChangePromise;
          }(e);
        }, function (r) {
          return zr(e, r), Promise.resolve();
        }, n, i), e._backpressure = void 0, e._backpressureChangePromise = void 0, e._backpressureChangePromise_resolve = void 0, kr(e, !0), e._transformStreamController = void 0;
      }(this, new Promise(function (e) {
        u = e;
      }), n, s, a, l), function (e, r) {
        var t = Object.create(Ir.prototype),
            o = function o(e) {
          try {
            return Mr(t, e), Promise.resolve();
          } catch (e) {
            return Promise.reject(e);
          }
        },
            n = r.transform;

        if (void 0 !== n) {
          if ("function" != typeof n) throw new TypeError("transform is not a method");

          o = function o(e) {
            return d(n, r, [e, t]);
          };
        }

        var i = c(r, "flush", 0, [t]);
        !function (e, r, t, o) {
          r._controlledTransformStream = e, e._transformStreamController = r, r._transformAlgorithm = t, r._flushAlgorithm = o;
        }(e, t, o, i);
      }(this, e);
      var h = f(e, "start", [this._transformStreamController]);
      u(h);
    }

    return Object.defineProperty(e.prototype, "readable", {
      get: function get() {
        if (!1 === Wr(this)) throw xr("readable");
        return this._readable;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "writable", {
      get: function get() {
        if (!1 === Wr(this)) throw xr("writable");
        return this._writable;
      },
      enumerable: !0,
      configurable: !0
    }), e;
  }();

  function Wr(e) {
    return !!n(e) && !!Object.prototype.hasOwnProperty.call(e, "_transformStreamController");
  }

  function Br(e, r) {
    Ge(e._readable._readableStreamController, r), zr(e, r);
  }

  function zr(e, r) {
    Lr(e._transformStreamController), Q(e._writable._writableStreamController, r), !0 === e._backpressure && kr(e, !1);
  }

  function kr(e, r) {
    void 0 !== e._backpressureChangePromise && e._backpressureChangePromise_resolve(), e._backpressureChangePromise = new Promise(function (r) {
      e._backpressureChangePromise_resolve = r;
    }), e._backpressure = r;
  }

  var Ir = function () {
    function e() {
      throw new TypeError("TransformStreamDefaultController instances cannot be created directly");
    }

    return Object.defineProperty(e.prototype, "desiredSize", {
      get: function get() {
        if (!1 === Fr(this)) throw Nr("desiredSize");
        return Je(this._controlledTransformStream._readable._readableStreamController);
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.enqueue = function (e) {
      if (!1 === Fr(this)) throw Nr("enqueue");
      Mr(this, e);
    }, e.prototype.error = function (e) {
      if (!1 === Fr(this)) throw Nr("error");
      !function (e, r) {
        Br(e._controlledTransformStream, r);
      }(this, e);
    }, e.prototype.terminate = function () {
      if (!1 === Fr(this)) throw Nr("terminate");
      !function (e) {
        var r = e._controlledTransformStream,
            t = r._readable._readableStreamController;
        !0 === Ke(t) && Ve(t);
        var o = new TypeError("TransformStream terminated");
        zr(r, o);
      }(this);
    }, e;
  }();

  function Fr(e) {
    return !!n(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledTransformStream");
  }

  function Lr(e) {
    e._transformAlgorithm = void 0, e._flushAlgorithm = void 0;
  }

  function Mr(e, r) {
    var t = e._controlledTransformStream,
        o = t._readable._readableStreamController;
    if (!1 === Ke(o)) throw new TypeError("Readable side is not in a state that permits enqueue");

    try {
      Qe(o, r);
    } catch (e) {
      throw zr(t, e), t._readable._storedError;
    }

    (function (e) {
      return !0 !== He(e);
    })(o) !== t._backpressure && kr(t, !0);
  }

  function Dr(e, r) {
    return e._transformAlgorithm(r).catch(function (r) {
      throw Br(e._controlledTransformStream, r), r;
    });
  }

  function Nr(e) {
    return new TypeError("TransformStreamDefaultController.prototype." + e + " can only be used on a TransformStreamDefaultController");
  }

  function xr(e) {
    return new TypeError("TransformStream.prototype." + e + " can only be used on a TransformStream");
  }

  var Yr = Object.assign || function (e) {
    for (var r = [], t = 1; t < arguments.length; t++) {
      r[t - 1] = arguments[t];
    }

    for (var o = Object(e), n = 0, i = r; n < i.length; n++) {
      var a = i[n];

      for (var s in a) {
        Object.prototype.hasOwnProperty.call(a, s) && (o[s] = a[s]);
      }
    }

    return o;
  };

  void 0 !== t && Yr(t, {
    ReadableStream: he,
    WritableStream: R,
    ByteLengthQueuingStrategy: Cr,
    CountQueuingStrategy: Ar,
    TransformStream: Or
  }), e.ReadableStream = he, e.WritableStream = R, e.ByteLengthQueuingStrategy = Cr, e.CountQueuingStrategy = Ar, e.TransformStream = Or, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});